var serverlessVercelPackageJson = {
  type: "module"
};
export {
  serverlessVercelPackageJson
};
//# sourceMappingURL=vc-package-base.js.map
